/** アンサンブル表示メンバーの選択肢 */
export const EnsampleDisplayMember = {
  All: 'all',
  TopMidBot: 'topMidBot',
  Top: 'top',
  Bot: 'bot',
  Band: 'band',
} as const;

export type EnsampleDisplayMember = (typeof EnsampleDisplayMember)[keyof typeof EnsampleDisplayMember];

const ENSAMPLE_DISPLAY_MEMBER_VALUES: readonly string[] = Object.values(EnsampleDisplayMember);

/**
 * 値が EnsampleDisplayMember の enum に含まれる場合はそのまま返し、
 * 含まれない場合はデフォルト値 (TopMidBot) を返す。
 * localStorage 由来など外部から流入する値の正規化に使う。
 */
export const normalizeEnsampleDisplayMember = (value: unknown): EnsampleDisplayMember => {
  if (typeof value === 'string' && ENSAMPLE_DISPLAY_MEMBER_VALUES.includes(value)) {
    return value as EnsampleDisplayMember;
  }
  return EnsampleDisplayMember.TopMidBot;
};
